import _objectWithoutProperties from "/home/circleci/repo/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import React, { useRef } from 'react';
import { Text } from '../Text';
import { useSpacing } from '../../api/spacing/useSpacing';
import { StyledTable, TableCaption, TableWrapper } from './Table.styles';
import { TableContext } from './Table.context';
var captionId = 0;

var getCaptionId = function getCaptionId() {
  return "Cap-".concat(captionId++);
};

export var Table = React.forwardRef(function (_ref, ref) {
  var caption = _ref.caption,
      children = _ref.children,
      fixedLayout = _ref.fixedLayout,
      _ref$displayMode = _ref.displayMode,
      displayMode = _ref$displayMode === void 0 ? 'auto' : _ref$displayMode,
      passedId = _ref.id,
      restProps = _objectWithoutProperties(_ref, ["caption", "children", "fixedLayout", "displayMode", "id"]);

  var _useRef = useRef(getCaptionId()),
      internalId = _useRef.current;

  return React.createElement(TableWrapper, {
    outerSpacing: useSpacing(restProps),
    role: "region",
    "aria-labelledby": caption ? internalId : undefined,
    tabIndex: 0,
    id: passedId,
    ref: ref,
    displayMode: displayMode
  }, React.createElement(StyledTable, {
    role: "table",
    fixedLayout: fixedLayout,
    displayMode: displayMode
  }, caption && React.createElement(TableCaption, {
    displayMode: displayMode
  }, React.createElement(Text, {
    as: "span",
    variant: "order3",
    id: internalId
  }, caption)), React.createElement(TableContext.Provider, {
    value: {
      displayMode: displayMode
    }
  }, children)));
});
Table.displayName = 'Table';